
import { defineComponent } from "vue";
import ButtonRequest from "../Generics/ButtonRequest.vue";

export default defineComponent({
  components: { ButtonRequest },
  name: "HeaderBank",
  data() {
    return {
      headerClass: "header-container" as String,
    };
  },
  methods: {
    handleResize() {
      const screenWidth = window.innerWidth;
      if (screenWidth > 600) {
        this.headerClass = "header-container";
      }
    },
    changeBackground() {
      console.log(this.opacit)
      if (this.headerClass == "header-container") {
        this.headerClass = "header-container-opacity";
      } else {
        this.headerClass = "header-container";
      }
    },
  },
  watch: {
    // sempre que a propriedade opacity muda, esta função será chamada
    opacit() {
      this.changeBackground();
    }
  },
  props: {
    opacit: {
      type: Boolean,
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
});
